<template>
  <div>
    <nav aria-label="breadcrumb" class="breadcrumb-nav mb-3">
      <div class="container">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/dashboard">Home</router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link to="/meeting">Meeting</router-link>
          </li>
          <li class="breadcrumb-item active" aria-current="page">
            Crea il meeting
          </li>
        </ol>
      </div>
      <!-- End .container -->
    </nav>
    <!-- End .breadcrumb-nav -->

    <LoadedComponent :loading="loading" />

    <div class="checkout" v-if="!loading">
      <div class="container">
        <div class="row pb-4">
          <div class="col-lg-12">
            <h2 class="checkout-title" style="font-size: 3rem">
              Nuovo meeting
            </h2>
            <!-- End .checkout-title -->
            <ul class="nav nav-tabs nav-tabs-bg" id="tabs-1" role="tablist">
              <li class="nav-item">
                <a class="nav-link active" id="tab-1-tab" data-toggle="tab" href="#tab-1" role="tab"
                  aria-controls="tab-1" aria-selected="true">Dati del meeting</a>
              </li>
            </ul>

            <div class="tab-content tab-content-border" id="tab-content-1">
              <div class="tab-pane fade show active" id="tab-1" role="tabpanel" aria-labelledby="tab-1-tab">
                <form class="pt-4 pr-4 pl-4" @submit.prevent="create_meeting">
                  <div class="row">
                    <div class="col-md-12">
                      <ul>
                        <li v-for="(errorMessage, key) in errors" :key="key">
                          <div class="alert alert-danger">
                            {{ errorMessage[0] }}
                          </div>
                        </li>
                      </ul>
                    </div>

                    <div class="col-sm-8">
                      <label for="nome_caso">Titlo del meeting *</label>
                      <input type="text" class="form-control" id="nome_caso" placeholder="Scrivi il titolo del meeting"
                        v-model="meeting.activity.name" />
                    </div>
                    <!-- End .col-sm-6 -->

                    <div class="col-sm-4">
                      <label for="linkedin_publish" class="form-label">Pubblicazione su linkedin *</label>
                      <select class="form-control" id="linkedin_publish" v-model="meeting.activity.status_linkedin">
                        <option value="0">Non pubblicare su linkedin</option>
                        <option value="1">Pubblica su linkedin</option>
                      </select>

                      <div class="alert alert-danger" v-if="
                        errors.activity && errors.activity.status_linkedin
                      ">
                        {{ errors.activity.status_linkedin[0] }}
                      </div>
                    </div>
                    <!-- End .col-sm-6 -->

                    <div class="col-md-4">
                      <label for="select2Multiple">Autore *</label>
                      <select class="js-example-basic-single form-control" name="autore_id" v-model="meeting.author_id">
                        <option value="0" selected disabled>
                          Seleziona l'autore
                        </option>

                        <option v-for="author in authors" :key="author.id" :value="author.id">
                          {{ author.text }}
                        </option>
                      </select>

                      <div class="alert alert-danger" v-if="errors.author_id">
                        {{ errors.author_id[0] }}
                      </div>
                    </div>

                    <div class="col-md-4">
                      <label for="date_inizio">Data ora inizio * </label>
                      <input type="datetime-local" id="meeting-time" class="form-control"
                        v-model="meeting.datetime_start" :min="meeting.datetime_start" />

                      <div class="alert alert-danger" v-if="errors.datetime_start">
                        {{ errors.datetime_start[0] }}
                      </div>
                    </div>

                    <div class="col-md-4">
                      <label for="date_inizio">Data ora fine * </label>

                      <input type="datetime-local" id="meeting-time" class="form-control" v-model="meeting.datetime_end"
                        :min="meeting.datetime_end" />
                      <div class="alert alert-danger" v-if="errors.datetime_end">
                        {{ errors.datetime_end[0] }}
                      </div>
                    </div>

                    <div class="col-sm-6">
                      <label for="speakers">Relatori *</label>
                      <Select2 v-model="meeting.meeting_invitations" :options="users" :settings="{
                        multiple: true,
                        selectionCssClass: 'w-100',
                      }" :placeholder="'Seleziona gli utenti'" />

                      <div class="alert alert-danger" v-if="errors.meeting_invitations">
                        {{ errors.meeting_invitations[0] }}
                      </div>
                    </div>

                    <div class="col-sm-6">
                      <label for="speakers">Partecipanti *</label>
                      <Select2 v-model="meeting.meeting_partecipants" :options="users" :settings="{
                        multiple: true,
                        selectionCssClass: 'w-100',
                      }" :placeholder="'Seleziona gli utenti'"></Select2>
                    </div>

                    <div class="col-sm-6">
                      <div class="icheck-wetasphalt mt-3">
                        <input type="checkbox" v-model="meeting.register" id="chb1" checked />
                        <label for="chb1">Registrazione Meeting </label>
                      </div>
                    </div>

                    <div class="col-md-6">
                      <label for="company_edit" class="form-label">Azienda
                      </label>
                      <select class="form-control" id="company_edit" name="company_id"
                        v-model="meeting.activity.company_id" required>
                        <option :value="null" selected>Nessuno sponsor</option>
                        <option v-for="company in companies" :key="company.id" :value="company.id">
                          {{ company.name }}
                        </option>
                      </select>

                      <div class="alert alert-danger" v-if="errors.activity && errors.activity.company_id">
                        {{ errors.activity.company_id[0] }}
                      </div>
                    </div>

                    <div class="col-sm-12 mt-2">
                      <label for="descrizione">Descrizione del meeting </label>

                      <textarea class="form-control" id="descrizione" rows="3" name="descrizione"
                        placeholder="Spiegazione del tuo post" v-model="meeting.activity.description"></textarea>

                      <div class="alert alert-danger" v-if="errors.activity && errors.activity.description">
                        {{ errors.activity.description[0] }}
                      </div>
                    </div>

                    <div class="col-sm-12 mt-2">
                      <div class="input-group mb-3">
                        <div class="custom-file">
                          <input type="file" class="custom-file-input" name="link_2" @change="handleFileUpload"
                            id="link_2" aria-describedby="inputGroupFileAddon01"
                            accept="image/png, image/jpeg, image/jpg" />
                          <label class="custom-file-label text-center" for="link_2" id="labelsfiles">{{ nameFiles
                            }}</label>
                        </div>
                      </div>
                    </div>

                    <div class="col-sm-12 mt-2">
                      <label for="locandina_pdf">Locandina pdf</label>
                      <div class="input-group mb-3">
                        <div class="custom-file">
                          <input type="file" class="custom-file-input" name="locandina_pdf"
                            @change="handleFileUploadPDf" id="locandina_pdf" aria-describedby="inputGroupFileAddon02"
                            accept="application/pdf" />
                          <label class="custom-file-label text-center" for="locandina_pdf" id="labelspdffile">{{
                            namePdfFiles }}</label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row flex-column pb-2 pl-2 pr-2">
                    <div class="flex-row">
                      <button type="submit" class="btn btn-primary float-right">
                        Pubblica il meeting <i class="las la-save"></i>
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import httpauth from "@/services/httpauth.js";
import LoadedComponent from "@/components/LoadedComponent.vue";
import httpservices from "@/services/httpservices.js";
import router from "@/router";
import Select2 from "vue3-select2-component";
import { useAuth } from "@/stores/auth.js";

export default {
  name: "CreateMeeting",
  components: {
    Select2,
    LoadedComponent,
  },
  props: [],
  data() {
    return {
      meeting: {
        activity: {
          name: "",
          status_linkedin: 0,
          description: "",
          company_id: null,
        },
        author_id: 0,
        datetime_start: new Date(),
        datetime_end: new Date(),
        meeting_invitations: [],
        meeting_partecipants: [],
        register: true,
      },
      attachments: [],
      formatting_date_start: "",
      formatting_date_end: "",
      users: [],
      companies: [],
      authors: [],
      errors: [],
      messageErrorAttachments: "",
      loading: false,
      nameFiles: "Scegli i file (MAX 1 GIGA)",
      namePdfFiles: "Scegli la locandina PDF (MAX 1 GIGA)",
      selectedFile: null,
    };
  },
  mounted() {
    this.loadCompanies();
    this.fetchUsers();
    // Formatta la data e l'ora attuali nel formato corretto per datetime-local
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0"); // Aggiungi un 0 se il mese è inferiore a 10
    const day = String(now.getDate()).padStart(2, "0"); // Aggiungi un 0 se il giorno è inferiore a 10
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    this.meeting.datetime_end =
      year + "-" + month + "-" + day + " " + hours + ":" + minutes;
    this.meeting.datetime_start =
      year + "-" + month + "-" + day + " " + hours + ":" + minutes;
    console.log(this.meeting.datetime_start);
  },

  methods: {
    async upload_attachments(id) {
      console.log(this.selectedFile);
      await httpservices.uploadCovers(this.selectedFile, id, "meeting")
        .then(() => {
          this.loading = false;
          this.nameFiles = "Scegli i file (MAX 1 GIGA)";
        }).catch((error) => {
          if (error.response.data.message)
          {
            localStorage.setItem(
              "messageErrorMeeting",
              error.response.data.message
            );
          }
        });
    },
    async loadCompanies() {
      await httpservices
        .getCompany()
        .then((response) => {
          this.companies = response.data.data;
        })
        .catch((error) => {
          console.error(error);
        });
    },

    async create_meeting() {
      this.loading = true;
      await httpauth
        .post("/meetings/store", this.meeting)
        .then(async (response) => {
          localStorage.setItem("messageSuccessMeeting", response.data.message);
          if (this.selectedFile != null)
          {
            await this.upload_attachments(response.data.data.id);
          }
          if (this.attachments.length > 0)
          {

            await this.uploadFiles(response.data.data.id);
          }

          if (response.data.message == "Redirect")
          {
            localStorage.setItem("linkedincategory", "meeting");
            localStorage.setItem("linkedinslug", response.data.data.slug);
            location.href = response.data.data.link_redirect;
          }
          this.loading = false;
          router.push("/meeting");
        })
        .catch((error) => {
          this.loading = false;
          if (
            error.response.status == 401 &&
            error.response.data.message == "Unauthenticated."
          )
          {
            const auth = useAuth();
            auth.clearToken();
            window.location.href = "/";
          }

          if (error.response.data.errors)
          {
            this.errors = error.response.data.errors;
          }
        });
    },
    handleFileUpload(event) {
      const maxSize = 1 * 1024 * 1024 * 1024;
      const files = event.target.files[0];
      const totalSize = files.size;
      const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
      if (totalSize <= maxSize)
      {
        if (
          !allowedTypes.includes(files.type) ||
          !httpservices.checkDicom(files)
        )
        {
          alert("Per favore seleziona un file valido (JPEG/JPG/PNG).");
          this;
          return;
        }
        this.nameFiles = files.name;
        this.selectedFile = files;
      } else
      {
        alert("La dimensione totale dei file supera 1 GB");
      }
    },
    async uploadFiles(id) {
      console.log(this.attachments);

      await httpservices
        .uploadAttachments(this.attachments[0], id, "meeting", 1, 0)
        .then(() => {
          this.nameFiles = "Scegli i file (MAX 1 GIGA)";
          router.push("/library");
        })
        .catch((error) => {
          if (error.response.data.errors)
          {
            this.errors = error.response.data.errors;
          }
          if (
            error.response.status == 401 &&
            error.response.data.message == "Unauthenticated."
          )
          {
            const auth = useAuth();
            auth.clearToken();
            window.location.href = "/";
          }
          console.log(error);
        });
    },
    handleFileUploadPDf(event) {
      const maxSize = 1 * 1024 * 1024 * 1024;
      const files = Array.from(event.target.files);
      const totalSize = files.reduce(
        (accumulator, file) => accumulator + file.size,
        0
      );
      const validFiles = [];
      if (totalSize <= maxSize)
      {
        const allowedTypes = [
          "application/pdf"
        ];
        Array.from(files).forEach((file) => {
          // Esegui l'azione desiderata su ogni file
          if (
            !allowedTypes.includes(file.type) ||
            !httpservices.checkDicom(file)
          )
          {
            alert(
              "Per favore seleziona un file valido (PDF)."
            );
            this;
            return;
          }
          validFiles.push(file.name);
        });

        this.attachments = files;
        this.namePdfFiles = validFiles.join(", ");
      } else
      {
        alert("La dimensione totale dei file supera 1 GB");
      }
    },


    async fetchUsers() {
      await httpservices
        .getUsers()
        .then((response) => {
          var users = response.data.data;
          this.users = users.map((user) => ({
            id: user.id,
            text: user.full_name,
          }));
          this.authors = users.map((user) => ({
            id: user.id,
            text: user.full_name,
          }));
          this.users.unshift({ id: "allUsers", text: "A tutti gli utenti" });
        })
        .catch((error) => {
          if (
            error.response.status == 401 &&
            error.response.data.message == "Unauthenticated."
          )
          {
            const auth = useAuth();
            auth.clearToken();
            window.location.href = "/";
          }
        });
    },
  },
};
</script>
<style>
.dp__input {
  height: 40px !important;
  font-size: 15px !important;
}

.dp__icon {
  width: 15px !important;
  height: 15px !important;
}

.dp__cell_inner {
  font-size: 15px;
}

.dp__calendar_header_item {
  font-size: 13px;
}

.dp__month_year_select {
  font-size: 13px !important;
}

.dp__action_button {
  font-size: 15px;
}

.dp__selection_preview {
  font-size: 12px;
}
</style>